module.exports = __webpack_public_path__ + "img/xrfl_rule.421353b3.webp";